module.exports = __webpack_public_path__ + "img/mexico86.f853e6ce.jpg";